import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { TrackJs } from '../../../models/utils/logging.interfaces';

declare global {
  interface Window {
    trackJs: TrackJs;
  }
}

/**
 * Service for controlling logging.
 */
@Injectable({
  providedIn: 'root'
})
export class LoggingService implements ErrorHandler {
  isTest = false;
  app = 'no-app-defined';
  library = 'no-library-defined';
  feature = 'no-feature-defined';

  constructor(@Inject(PLATFORM_ID) private platformId: NonNullable<unknown>) {}

  // TODO(Sergio): replace all this with IDP logging with Winston.
  /**
   * Run all logs through this function.
   */
  log(message: string): void {
    if (!this.isTest) {
      if (this.isTrackJs()) {
        this.handleError(message);
      } else {
        console.error(new Error(message));
      }
    }
  }

  handleError(error: string) {
    if (error && this.isTrackJs()) {
      this.addMetadata('App', this.app);
      this.addMetadata('Library', this.library);
      this.addMetadata('Feature', this.feature);
      if (isPlatformBrowser(this.platformId)) {
        this.addMetadata('TeaLeafId', this.getTealeafId());
      }
      window.trackJs.track(error);
    }
  }

  isTrackJs(): boolean {
    return window && 'trackJs' in window ? true : false;
  }

  addMetadata(key: string, value: string) {
    window?.trackJs?.addMetadata(key, value);
  }

  getTealeafId() {
    const _teaLeafId = 'no-id-defined';
    const result = new RegExp(
      '(?:^|; )' + encodeURIComponent(_teaLeafId) + '=([^;]*)'
    ).exec(document.cookie);
    return result ? result[1] : '';
  }
}
